module.exports = __webpack_public_path__ + "media/images/application/template/email-773801c598db8d56b32537e19e90b8e2.svg";